import { useEffect } from 'react';

/**
 * Forces the browser to keep scroll position manual rather than automatically
 * restoring it on navigation. Useful for client-side routed apps when you want
 * full control over scroll behaviour.
 */
export const useDisableScrollRestoration = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      const original = (window.history as any).scrollRestoration;

      try {
        window.history.scrollRestoration = 'manual';
        // Ensure we start at top of the page on first render.
        window.scrollTo(0, 0);
      } catch {
        /* Some browsers make this property read-only */
      }

      // Optionally restore previous value on unmount.
      return () => {
        try {
          window.history.scrollRestoration = original;
        } catch {
          /* ignore */
        }
      };
    }
  }, []);
}; 